<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="门店名称">
                <a-input v-model="queryParam.storeName" placeholder="请输入门店名称" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="商家名称">
                <a-input v-model="queryParam.merchantName" placeholder="请输入商家名称" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="要货单号">
                <a-input v-model="queryParam.purchaseOrderNo" placeholder="请输入要货单号" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="报损类型">
                <a-select v-model="queryParam.lossType" placeholder="请选择" allow-clear>
                  <a-select-option :value="1">门店承担</a-select-option>
                  <a-select-option :value="2">平台承担</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48">
<!--            <a-col :md="6" :sm="24">-->
<!--              <a-form-item label="报损状态">-->
<!--                <a-select v-model="queryParam.lossStatus" placeholder="请选择" allow-clear>-->
<!--                  <a-select-option :value="0">待审核</a-select-option>-->
<!--                  <a-select-option :value="1">已通过</a-select-option>-->
<!--                  <a-select-option :value="2">已拒绝</a-select-option>-->
<!--                </a-select>-->
<!--              </a-form-item>-->
<!--            </a-col>-->
            <a-col :md="18" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery">
                  <a-icon type="search" />查询
                </a-button>
                <a-button style="margin-left: 8px" @click="resetQuery">
                  <a-icon type="redo" />重置
                </a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="pagination"
        @change="handleTableChange"
        :bordered="tableBordered"
      />
    </a-card>

    <!-- 详情弹窗 -->
    <a-modal
      title="报损单详情"
      :visible="detailVisible"
      :footer="null"
      @cancel="detailVisible = false"
      width="1000px"
    >
      <a-descriptions bordered :column="2" v-if="currentDetail">
        <a-descriptions-item label="报损单号">{{ currentDetail.lossNo }}</a-descriptions-item>
        <a-descriptions-item label="要货单号">{{ currentDetail.purchaseOrderNo }}</a-descriptions-item>
        <a-descriptions-item label="门店名称">{{ currentDetail.storeName }}</a-descriptions-item>
        <a-descriptions-item label="商家名称">{{ currentDetail.merchantName }}</a-descriptions-item>
        <a-descriptions-item label="报损类型">
          <a-tag :color="currentDetail.lossType === 1 ? 'green' : 'blue'">
            {{ currentDetail.lossType === 1 ? '门店承担' : '平台承担' }}
          </a-tag>
        </a-descriptions-item>
<!--        <a-descriptions-item label="报损状态">-->
<!--          <a-tag :color="{ 0: 'orange', 1: 'green', 2: 'red' }[currentDetail.lossStatus] || 'default'">-->
<!--            {{ { 0: '待审核', 1: '已通过', 2: '已拒绝' }[currentDetail.lossStatus] || '-' }}-->
<!--          </a-tag>-->
<!--        </a-descriptions-item>-->
        <a-descriptions-item label="报损总金额">¥{{ currentDetail.lossAmount ? parseFloat(currentDetail.lossAmount).toFixed(2) : '0.00' }}</a-descriptions-item>
        <a-descriptions-item label="创建时间">{{ parseTime(currentDetail.createTime) }}</a-descriptions-item>
<!--        <a-descriptions-item label="审核时间">{{ parseTime(currentDetail.approveTime) }}</a-descriptions-item>-->
<!--        <a-descriptions-item label="审核人">{{ currentDetail.approverName || '-' }}</a-descriptions-item>-->
<!--        <a-descriptions-item label="拒绝原因" :span="2">{{ currentDetail.rejectReason || '-' }}</a-descriptions-item>-->
      </a-descriptions>
      <a-divider>报损明细</a-divider>
      <a-table
        rowKey="id"
        :columns="itemColumns"
        :data-source="currentDetail?.items || []"
        :pagination="false"
        size="small"
      />
    </a-modal>

    <!-- 审核弹窗 -->
    <a-modal
      title="审核报损单"
      :visible="approveVisible"
      @ok="handleApproveSubmit"
      @cancel="approveVisible = false"
    >
      <a-form-model :model="approveForm" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
        <a-form-model-item label="审核结果">
          <a-radio-group v-model="approveForm.isApproved">
            <a-radio :value="true">通过</a-radio>
            <a-radio :value="false">拒绝</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="拒绝原因" v-if="approveForm.isApproved === false">
          <a-textarea v-model="approveForm.rejectReason" placeholder="请输入拒绝原因" :rows="4" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </page-header-wrapper>
</template>

<script>
import { getLossList, getLossDetail, approveLoss } from '@/api/retail/purchase'
import { tableMixin } from '@/store/table-mixin'
import moment from 'moment'

export default {
  name: 'PurchaseLoss',
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      loading: false,
      detailVisible: false,
      approveVisible: false,
      currentDetail: null,
      approveForm: {
        lossId: undefined,
        isApproved: true,
        rejectReason: ''
      },
      queryParam: {
        storeName: undefined,
        merchantName: undefined,
        purchaseOrderNo: undefined,
        lossType: undefined,
        lossStatus: undefined,
        pageNo: 1,
        pageSize: 10
      },
      pagination: {
        total: 0,
        current: 1,
        pageSize: 10,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: total => `共 ${total} 条`
      },
      columns: [
        {
          title: '报损单号',
          dataIndex: 'lossNo',
          width: 180,
          align: 'center'
        },
        {
          title: '要货单号',
          dataIndex: 'purchaseOrderNo',
          width: 180,
          align: 'center'
        },
        {
          title: '门店名称',
          dataIndex: 'storeName',
          width: 150,
          align: 'center'
        },
        {
          title: '商家名称',
          dataIndex: 'merchantName',
          width: 150,
          align: 'center'
        },
        {
          title: '报损类型',
          dataIndex: 'lossType',
          width: 100,
          align: 'center',
          customRender: (text) => {
            return text === 1 ? '门店承担' : '平台承担'
          }
        },
        // {
        //   title: '报损状态',
        //   dataIndex: 'lossStatus',
        //   width: 100,
        //   align: 'center',
        //   customRender: (text) => {
        //     const colorMap = { 0: 'orange', 1: 'green', 2: 'red' }
        //     const textMap = { 0: '待审核', 1: '已通过', 2: '已拒绝' }
        //     return this.$createElement('a-tag', { props: { color: colorMap[text] || 'default' } }, textMap[text] || '-')
        //   }
        // },
        {
          title: '报损金额(元)',
          dataIndex: 'lossAmount',
          width: 120,
          align: 'center',
          customRender: (text) => {
            return `¥${text ? parseFloat(text).toFixed(2) : '0.00'}`
          }
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          width: 180,
          align: 'center',
          customRender: (text) => {
            return this.parseTime(text)
          }
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 150,
          align: 'center',
          customRender: (text, record) => {
            const buttons = []
            buttons.push(this.$createElement('a', {
              on: { click: () => this.handleDetail(record) },
              directives: [{ name: 'hasPermi', value: 'retail:purchase:loss' }]
            }, [this.$createElement('a-icon', { props: { type: 'eye' } }), '详情']))

            if (record.lossStatus === 0) {
              buttons.push(this.$createElement('a-divider', { props: { type: 'vertical' } }))
              buttons.push(this.$createElement('a', {
                on: { click: () => this.handleApprove(record) },
                directives: [{ name: 'hasPermi', value: 'retail:purchase:loss:approve' }]
              }, [this.$createElement('a-icon', { props: { type: 'check' } }), '审核']))
            }
            return buttons
          }
        }
      ],
      itemColumns: [
        { title: '商品名称', dataIndex: 'goodsName', width: 200, align: 'center' },
        { title: 'SKU名称', dataIndex: 'skuName', width: 150, align: 'center' },
        { title: '要货数量', dataIndex: 'applyCount', width: 100, align: 'center' },
        { title: '收货数量', dataIndex: 'receiveCount', width: 100, align: 'center' },
        { title: '报损数量', dataIndex: 'lossCount', width: 100, align: 'center' },
        { title: '单价(元)', dataIndex: 'unitPrice', width: 100, align: 'center', customRender: (text) => `¥${text ? parseFloat(text).toFixed(2) : '0.00'}` },
        { title: '报损金额(元)', dataIndex: 'lossAmount', width: 120, align: 'center', customRender: (text) => `¥${text ? parseFloat(text).toFixed(2) : '0.00'}` }
      ]
    }
  },
  created() {
    this.getList()
  },
  methods: {
    moment,
    parseTime(time) {
      return time ? moment(time).format('YYYY-MM-DD HH:mm:ss') : '-'
    },
    getList() {
      this.loading = true
      getLossList(this.queryParam).then(response => {
        this.list = response.data?.records || []
        this.pagination.total = response.data?.total || 0
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    handleTableChange(pagination) {
      this.queryParam.pageNo = pagination.current
      this.queryParam.pageSize = pagination.pageSize
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.getList()
    },
    handleQuery() {
      this.queryParam.pageNo = 1
      this.getList()
    },
    resetQuery() {
      this.queryParam = {
        storeName: undefined,
        merchantName: undefined,
        purchaseOrderNo: undefined,
        lossType: undefined,
        lossStatus: undefined,
        pageNo: 1,
        pageSize: 10
      }
      this.getList()
    },
    handleDetail(record) {
      getLossDetail(record.id).then(response => {
        this.currentDetail = response.data
        this.detailVisible = true
      })
    },
    handleApprove(record) {
      this.approveForm.lossId = record.id
      this.approveForm.isApproved = true
      this.approveForm.rejectReason = ''
      this.approveVisible = true
    },
    handleApproveSubmit() {
      const params = {
        lossId: this.approveForm.lossId,
        isApproved: this.approveForm.isApproved
      }
      if (!this.approveForm.isApproved && !this.approveForm.rejectReason) {
        this.$message.warning('请输入拒绝原因')
        return
      }
      if (this.approveForm.rejectReason) {
        params.rejectReason = this.approveForm.rejectReason
      }
      approveLoss(params).then(() => {
        this.$message.success('审核成功')
        this.approveVisible = false
        this.getList()
      })
    }
  }
}
</script>
